import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCampaign = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.875 1.10549V6.31463C17.5078 6.6314 18 7.47613 18 8.42644C18 9.41196 17.5078 10.2567 16.875 10.5735V15.7474C16.875 16.205 16.5938 16.6273 16.1719 16.8033C15.75 16.9793 15.2578 16.8737 14.9414 16.5569L13.3945 15.0083C11.707 13.3188 9.42188 12.3685 7.03125 12.3685H6.75V16.8737C6.75 17.5072 6.22266 18 5.625 18H3.375C2.74219 18 2.25 17.5072 2.25 16.8737V12.3685C0.984375 12.3685 0 11.383 0 10.1159V6.73699C0 5.5051 0.984375 4.48439 2.25 4.48439H7.03125C9.42188 4.48439 11.707 3.53407 13.3945 1.84462L14.9414 0.331156C15.2578 0.0143839 15.75 -0.0912068 16.1719 0.0847777C16.5938 0.260762 16.875 0.683125 16.875 1.10549ZM14.625 3.81565C12.5508 5.71628 9.84375 6.73699 7.03125 6.73699H6.75V10.1159H7.03125C9.84375 10.1159 12.5508 11.1718 14.625 13.0724V3.81565Z",
		fill: "currentColor"
	})
});
export default SvgCampaign;
